export default "__VITE_ASSET__CY0OCZGQ__";